export const useSxStyles = () => {
  return {
    companyLogoText: {
      color: 'black', // to be customizable depending on the background color of the UpperBar ???
      fontSize: 24,
    },
    companyLogoImg: {
      maxHeight: '36px',
      width: 'auto',
      maxWidth: '200px',
      verticalAlign: 'middle',
      objectFit: 'contain',
    },
  };
};
